import React from "react";
import { Col, Space } from "antd";

import InformationTitleList from "../../components/InformationTitleList";
import InformationSubtitleList from "../../components/InformationSubtitleList";
import FaqList from "../../components/FaqList";

function CustomerManagement() {
    return (
        <div className="container">
            <Space size={30} direction="vertical" style={{ width: "100%" }}>
                <h3 className="title">고객지원 관리</h3>
                <InformationTitleList />
                <InformationSubtitleList informationTitleId={""} />
                <FaqList />
            </Space>
        </div>
    );
}

export default CustomerManagement;
